/**
 * 域名的 map 映射表
 */
// 目前前端有两个域名，不同域名下接口请求不同的host
const apiDomainMap = {
  '.zhuanzhuan.com': 'app.zhuanzhuan.com',
  '.caihuoxia.com': 'app.caihuoxia.com'
}

const getApiDomain = function () {
  const key = location.host.replace(/[\dA-Za-z]{1,}\./, '.')
  return apiDomainMap[key] || 'app.caihuoxia.com'
}

export default {
  appDomain: `https://${getApiDomain()}`,
  apolloDomain: 'https://feconf.zhuanzhuan.com',
  youpinApiDomain: 'https://youpinapi.zhuanzhuan.com',
  uApiDomain: 'https://uapi.zhuanzhuan.com'
}
